import { useMutation } from '@tanstack/react-query';
import type { RespondedType } from '@/models/response';
import { fetcher } from '@/utils/fetcher';
import { getDeviceTypeIdentifier } from '@/utils/get-standalone-mode';

export function updateDeviceToken(token: string): Promise<RespondedType> {
  return fetcher<RespondedType>('/UpdateDeviceToken', {
    DToken: token,
    DeviceType: getDeviceTypeIdentifier(),
  });
}

export default function useUpdateDeviceToken() {
  return useMutation<RespondedType, void, string>({
    mutationKey: ['/UpdateDeviceToken'],
    mutationFn: (params) => updateDeviceToken(params),
  });
}
